module.exports = __webpack_public_path__ + "img/envelope1.ab3be791.png";